import { ConfirmDialog } from 'primereact/confirmdialog';
import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { ApiAdimplencia } from '../../../../services/api';
import { confirmFooter } from '../../../confirmFooter';

function isContratoAtivo(value) {
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();

    if (['true', '1', 'ativo', 'active', 'sim', 'yes'].includes(normalized)) {
      return true;
    }

    if (['false', '0', 'inativo', 'inactive', 'nao', 'não', 'no'].includes(normalized)) {
      return false;
    }
  }

  if (typeof value === 'number') {
    return value === 1;
  }

  return value === true;
}

export default function CancelaContratante({ close, reload, itemInfo }) {

  const [showConfirm, setShowConfirm] = useState(true);
  const contratoAtivo = isContratoAtivo(itemInfo?.contratante_status);
  const acaoLabel = contratoAtivo ? 'Desativar contrato' : 'Reativar contrato';

  const message = contratoAtivo
    ? 'Deseja realmente desativar o contrato?'
    : 'Deseja realmente reativar o contrato?';

  async function handleConfirm() {
    try {

      const novoStatus = !contratoAtivo;

      const data = await ApiAdimplencia.patch(
        `/contratante/atualizar-status/${itemInfo.contratante_id}`,
        { contratante_status: novoStatus }
      );

      toast.success(`${novoStatus ? 'Contrato reativado' : 'Contrato desativado'} com sucesso!`);

      close();
      reload(); // Trigger reload after successful action
    } catch (error) {
      console.error(error);
      toast.error('Erro ao tentar realizar troca de status do contrato.');
    }
  }

  return (
    <>
      <ConfirmDialog
        onHide={() => close()}
        header={acaoLabel}
        message={message}
        pt={{
          root: {
              className: 'lg:w-1/4 md:w-1/2 w-full'
          }
      }}
        acceptLabel={acaoLabel}
        rejectLabel="Não"
        acceptClassName="outline-green-500 hover:outline-green-600 outline-2 outline bg-green-500 hover:bg-green-600 rounded-md w-full py-3 text-white transition duration-300"
        rejectClassName="outline-red-500 outline-2 outline rounded-md w-full py-3 text-red-500 hover:bg-red-500 hover:text-white transition duration-300"
        acceptIcon="pi pi-check"
        rejectIcon="pi pi-times"
        accept={() => handleConfirm()}
        reject={() => setShowConfirm(false)}
        draggable={false}
        footer={confirmFooter}
        visible
      />
    </>
  );
}
